"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borgo-val-di-taro": {
    "2c151cca": [{
      "hkey": "230b0231",
      "slug": "borgo-val-di-taro",
      "name": "Borgo Val di Taro",
      "primary": true,
      "skipSearch": false
    }],
    "gorro": [{
      "hkey": "230b0231",
      "slug": "borgo-val-di-taro",
      "name": "Borgo Val di Taro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b10434aa": [{
      "hkey": "230b0231",
      "slug": "borgo-val-di-taro",
      "name": "Borgo Val di Taro",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro": [{
      "hkey": "230b0231",
      "slug": "borgo-val-di-taro",
      "name": "Borgo Val di Taro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8b3757f3": [{
      "hkey": "230b0231",
      "slug": "borgo-val-di-taro",
      "name": "Borgo Val di Taro",
      "primary": true,
      "skipSearch": false
    }],
    "tiedoli": [{
      "hkey": "230b0231",
      "slug": "borgo-val-di-taro",
      "name": "Borgo Val di Taro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;